export default __webpack_public_path__ + "static/media/J736_CoC.0d747c82.pdf";